import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Options } from '@angular-slider/ngx-slider';
import { AjaxService } from 'src/app/ajax.service';


@Component({
  selector: 'app-threedview',
  templateUrl: './threedview.component.html',
  styleUrls: ['./threedview.component.scss'],
  providers: [AjaxService]

})
export class ThreedviewComponent implements OnInit {
  interval: any;
  intervalback: any;
  valueslider: number = 5;
  public activeTabIndex: number = 1;
  product :any = 'TRACK MOUNTED SCREEN 4 DECK';
  reqformshow: number = 1

  options: Options = {
    floor: 72,
    ceil: 169,
    vertical: false,
    showTicks: false,
    translate: (value: number): any => {
      return  null;
    },
  };
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  val = 71
  valback = 184
  v = 40;
  firstimg: any;
  firdisplay: any;
  otherdisplay:any;
  fromenvdisplay:any;
  fromfeeddisplay:any;
  vasechange: any;
  dust:any;
  metal:any;
  mousevalue : any;
  jaw : any;
  pow:any;
  lm:any;
  track:any;
  dpi:any;
  modalRef: any;
  closeResult: any;
  stylecheck: any;
  slideron = 0;
  isLoading: any;
  constructor(private AjaxServices: AjaxService,private modalService: NgbModal,private ngxService: NgxUiLoaderService) { }
  value: number = 72;
  sliderValue = 0;
 
//   ngAfterViewInit() {
//     this.isLoading = false;
//     console.log("test")
// }
  ngOnInit() {
        // loading part start
        this.ngxService.start();
        // return false
        setTimeout(() => 
          this.ngxService.stop(),
        13000);
        // loading part stop

        //autorotate start
        // this.interval = setInterval(() => {
        //   if(this.val == 168){
        //     clearInterval(this.interval);
        //     this.intervalback = setInterval(() => {
        //       if(this.valback == 72){
        //         clearInterval(this.intervalback);
        //       }else{
        //         this.functioncallback()
        //       }
        //     }, 60);
        //   }else{
        //     this.functioncall()
        //   }

        // }, 60);
            //autorotate stop
        this.firstimg = 1
     }
   
     private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }  
    open(content : any) {
      this.modalService.open(content,
     {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = 
           `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    // open(addnew: any) {
    //   this.modalRef = this.modalService.open(addnew, { backdrop: 'static', keyboard: false, size: 'lg' });
    //   this.modalRef.result.then((result: any) => {
    //     this.closeResult = `Closed with: ${result}`; 
    //   }, (reason: any) => {
    //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   });
    // };
    //  sliderEvent() {
    //    console.log(this.value)
    //   var changeval =  this.value - 44
    //   this.firstimg = 2 
    //   if(this.value <= 107){
    //     this.vasechange = document.getElementById("vasechange")
    //     this.vasechange.style.right = changeval - 11 +'%'
    //     this.vasechange.style.display = "inline"
    //     this.vasechange.style.opacity = 1;
    //   }
    //   if(this.value >= 108 && this.value <= 121){
    //     this.vasechange = document.getElementById("vasechange")
    //     this.vasechange.style.display = "none"
    //     this.vasechange.style.opacity = 1;
    //   }
    //   if(this.value >= 122 && this.value <= 140){
    //     this.vasechange = document.getElementById("vasechange")
    //     this.vasechange.style.display = "none"
    //     this.vasechange.style.opacity = 1;
    //   }
     
    //   if(this.value >= 141 && this.value <= 144){
    //     this.vasechange = document.getElementById("vasechange")
    //     this.vasechange.style.display = "none"
    //   }
      
    //   if(this.value >= 145 && this.value <= 156){
    //     this.vasechange.style.display = "none"

    //   }
    //   if(this.value >= 157 && this.value <= 170){
       
    //     this.vasechange.style.opacity = 1;
    //     this.vasechange.style.display = "inline"
    //     this.vasechange = document.getElementById("vasechange")
    //     this.vasechange.style.right = 28 +'%'
    //     if(this.value == 157){
    //       this.vasechange.style.opacity = 0.5;
    //     }
    //   }


    //   if(this.value <= 83){
    //     var changevalnew = this.value - 70
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.right =79 - changevalnew +'%'
    //     this.mousevalue.style.bottom =50 +'%'

    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.opacity = 1;

    //   }
    //   if(this.value == 82){
    //     this.mousevalue.style.opacity = 0.5;
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.bottom =50 +'%'

    //   }

    //   if(this.value >= 83 && this.value <= 94 ){
    //     this.mousevalue.style.display = "none"

    //   }
    //   if(this.value >= 94 && this.value <= 107 ){
    //     this.mousevalue.style.display = "none"
    //   }
    //   if(this.value == 107 ){
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.right =22+'%'
    //     this.mousevalue.style.bottom =50 +'%'

    //     this.mousevalue.style.opacity = 0.6;
    //   }
    //   if(this.value >= 108 && this.value <= 111 ){
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.right =19+'%'
    //     this.mousevalue.style.opacity = 1;
    //     this.mousevalue.style.bottom =50 +'%'

    //   }
    //   if(this.value >= 112 && this.value <= 121 ){
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.right =11+'%'
    //     this.mousevalue.style.bottom =50 +'%'

    //     this.mousevalue.style.opacity = 1;
    //   }
    //   if(this.value >= 122 && this.value <= 134){
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.right =8+'%'
    //     this.mousevalue.style.bottom =50 +'%'

    //     this.mousevalue.style.opacity = 1;
    //   }
      
     
    //     if(this.value >= 135 && this.value <= 139){
    //       this.value - 90 + 1
    //           this.mousevalue = document.getElementById("mousevalue")
    //           this.mousevalue.style.display = "inline"
    //           this.mousevalue.style.right =this.value - 123 + 1 +'%'
    //           this.mousevalue.style.opacity = 1;
    //           this.mousevalue.style.bottom =55 +'%'

    //           }
    //           if(this.value == 140){
    //             this.mousevalue = document.getElementById("mousevalue")
    //             this.mousevalue.style.display = "inline"
    //            this.mousevalue.style.right =21 +'%'
    //            this.mousevalue.style.opacity = 1;
    //            this.mousevalue.style.bottom =55 +'%'


    //             }
    //             if(this.value == 141){
    //               this.mousevalue = document.getElementById("mousevalue")
    //               this.mousevalue.style.display = "inline"
    //               this.mousevalue.style.right =22 +'%'
    //               this.mousevalue.style.opacity = 1;
    //               this.mousevalue.style.bottom =55 +'%'


    //               }
    //  if(this.value == 142 || this.value == 143){
    //   this.mousevalue = document.getElementById("mousevalue")
    //   this.mousevalue.style.display = "inline"
    //   this.mousevalue.style.right =27 +'%'
    //   this.mousevalue.style.opacity = 1;
    //   this.mousevalue.style.bottom =55 +'%'

    //   }
    //   if(this.value == 144 || this.value == 145){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =35 +'%'
    //     this.mousevalue.style.bottom =56 +'%'
    //     this.mousevalue.style.opacity = 1;
  
    //     }if(this.value == 146 ){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =36 +'%'
    //     this.mousevalue.style.bottom =55 +'%'
    //     this.mousevalue.style.opacity = 1;

    //   }
    //   if(this.value == 147 || this.value == 148){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =44 +'%'
    //   }if(this.value == 149 || this.value == 150){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =47 +'%'
    //   }if(this.value == 151){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =51 +'%'
    //   }if(this.value == 152){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =59 +'%'
    //   }if(this.value == 153){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =65 +'%'
    //   }if(this.value == 154){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =66 +'%'
    //   }if(this.value >= 155 && this.value <= 157){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =68 +'%'
    //   }
    //   if(this.value >= 158 && this.value <= 161){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =78 +'%'
    //   }
    //   if(this.value >= 165){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =85 +'%'
    //   }
    //   if(this.value >= 166 && this.value <= 170){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =89 +'%'
    //   }
    //   if(this.value >= 171 && this.value <= 177){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =89 +'%'
    //   }
    //   if(this.value >= 178 && this.value <= 180){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =85 +'%'
    //     this.mousevalue.style.bottom =55 +'%'
    //   }
    //   if(this.value >= 181 && this.value <= 184){
    //     this.mousevalue = document.getElementById("mousevalue")
    //     this.mousevalue.style.display = "inline"
    //     this.mousevalue.style.right =80 +'%'
    //     this.mousevalue.style.bottom =52 +'%'
    //   }
    //   this.firdisplay = document.getElementById("frame-" +this.value)
    //   this.firdisplay.style.display = "inline"
    //   for(let i = 72 ; i<= 184 ; i++){
    //     if(this.value != i ){
    //       this.otherdisplay = document.getElementById("frame-" +i)
    //       this.otherdisplay.style.display = "none"
    //     }
    //   }
    //  }
     sliderEvent(){

      // image show 
      this.firdisplay = document.getElementById("frame-" +this.value)
      this.firdisplay.style.display = "inline"
      for(let i = 72 ; i<= 169 ; i++){
        if(this.value != i ){
          this.otherdisplay = document.getElementById("frame-" +i)
          this.otherdisplay.style.display = "none"
        }
      }
      // console.log(this.value)
      var changeval =  this.value - 44
      this.firstimg = 2 
      // return false

      if(this.value == 72){
        this.lm = document.getElementById("lm")
        this.lm.style.right ='43%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '13%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '2%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='22%' 
        this.mousevalue.style.bottom =47 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='47%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='43%'
        this.dpi.style.bottom ='41%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='41%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
      }
      if(this.value == 73){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '13%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '2%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='22%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='42%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='48%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='71%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '67%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }

      if(this.value == 74 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '13%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '2%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='26%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='44%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='45%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='49%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='71%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '67%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }
      if(this.value == 75 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '13%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '2%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='29%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='46%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='47%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='50%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='71%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '70%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }

      if(this.value == 76 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '13%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '2%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='33%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='48%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='48%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='50%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='71%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '72%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }

      if(this.value == 77 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '13%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '2%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='36%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='50%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='49%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='53%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 0.5;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='71%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '76%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }
      if(this.value == 78 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '15%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '3%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='40%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity =1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='58%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='51%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='71%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='49%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '78%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }

      if(this.value == 79 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '17%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '4%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='44%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='39%'
        this.jaw.style.bottom =56 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='52%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='71%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='49%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '82%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }
     
      if(this.value == 80 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '18%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '4%'
        this.dust.style.bottom = '59%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='49%'
        this.mousevalue.style.bottom =46+'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='54%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='69%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='51%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '84%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }

      if(this.value == 81 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '20%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '6%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='53%'
        this.mousevalue.style.bottom = 46+'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='41%'
        this.jaw.style.bottom =58+'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='56%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='69%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='52%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '87%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }
      if(this.value == 82 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '22%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '8%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='55%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='42%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='57%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='69%'
        this.dpi.style.bottom ='37%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='53%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '89%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }
      if(this.value == 83 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '25%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '10%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='60%'
        this.mousevalue.style.bottom =46+'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='42%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='53%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '91%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }
      if(this.value == 84 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '27%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '13%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='62%'
        this.mousevalue.style.bottom =46+'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='53%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '92%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
      }
      if(this.value == 85 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '30%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '16%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='66%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='45%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='52%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='61%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
      }
      if(this.value == 86 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '20%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        
        this.track = document.getElementById("track")
        this.track.style.right ='55%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='71%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='54%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='62%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
      }
      if(this.value == 87 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '36%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '24%'
        this.dust.style.bottom = '58%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='75%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='63%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='55%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
      }
      if(this.value == 88 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '39%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '28%'
        this.dust.style.bottom = '59%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='56%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='77%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='43%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='58%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='64%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
      }
      if(this.value == 89 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '43%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;
        
        this.dust = document.getElementById("dust")
        this.dust.style.right = '33%'
        this.dust.style.bottom = '59%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='80%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='59%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='60%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='65%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='56%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '32%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

      }
      if(this.value == 90 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '47%'
        this.vasechange.style.bottom = '51%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '37%'
        this.dust.style.bottom = '59%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '36%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;


        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='84%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='43%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='62%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='66%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='56%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;
      }

      if(this.value == 91 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '71%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '29%'
        this.dust.style.bottom = '52%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 0.5;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='86%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='43%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='64%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='67%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='55%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='56%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;
      }

      if(this.value == 92 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '73%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '27%'
        this.dust.style.bottom = '52%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '47%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='89%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='42%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='66%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='68%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='32%'
        this.dpi.style.bottom ='43%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='28%'
        this.track.style.display = "none"
        this.track.style.opacity = 0.5;
      }

      if(this.value == 93 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;
        
        this.dust = document.getElementById("dust")
        this.dust.style.right = '26%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '52%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='91%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='42%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='68%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='69%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='30%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 94 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '78%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;
        
        this.dust = document.getElementById("dust")
        this.dust.style.right = '24%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '57%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='94%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='42%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='69%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='70%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='30%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 95 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '79%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 1;
        
        this.dust = document.getElementById("dust")
        this.dust.style.right = '24%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '60%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='94%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='42%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='70%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='70%'
        this.lm.style.bottom ='63%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 0.5;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='29%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 96 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 0.5;
        
        this.dust = document.getElementById("dust")
        this.dust.style.right = '22%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '66%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='94%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='42%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='72%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='60%'
        this.lm.style.bottom ='68%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='28%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 97 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;
        


        this.dust = document.getElementById("dust")
        this.dust.style.right = '21%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '71%'
        this.metal.style.bottom = '71%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;


        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='94%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 0.5;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =58+'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='73%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='27%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 98 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;
        

        this.dust = document.getElementById("dust")
        this.dust.style.right = '19%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '76%'
        this.metal.style.bottom = '72%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='18%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='75%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='26%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 99 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '57%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;
        

        this.dust = document.getElementById("dust")
        this.dust.style.right = '18%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '72%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='17%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='76%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='26%'
        this.dpi.style.bottom ='41%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 100 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '17%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '84%'
        this.metal.style.bottom = '72%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='16%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='77%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='71%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='43%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='43%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 101 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '17%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '89%'
        this.metal.style.bottom = '72%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='16%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='51%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='71%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='46%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity =1;
      }

      if(this.value == 102 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '14%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '89%'
        this.metal.style.bottom = '72%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='15%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='52%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='71%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='47%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 103 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '14%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '23%'
        this.metal.style.bottom = '59%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='15%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='52%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='71%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='47%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 104 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '13%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '25%'
        this.metal.style.bottom = '59%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =55+'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='53%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='71%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='43%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='49'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 105 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '13%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '26%'
        this.metal.style.bottom = '59%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='53%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='70%'
        this.lm.style.bottom ='62%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 0.5;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='43%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='49%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 106 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '27%'
        this.metal.style.bottom = '59%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =55+'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='54%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='42%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='50%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 107 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '28%'
        this.metal.style.bottom = '61%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='54%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='42%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='43%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='50%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 108 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '31%'
        this.metal.style.bottom = '61%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='41%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='55%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='42%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='25%'
        this.dpi.style.bottom ='43%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='51%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 109 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '33%'
        this.metal.style.bottom = '63%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='41%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='55%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='42%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='26%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='51%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 110 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '35%'
        this.metal.style.bottom = '63%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='43%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='56%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='42%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='27%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='51%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 111 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '75%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='16%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='37%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='42%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='28%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='52%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 112 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '75%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='16%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='37%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='53%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='29%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='52%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 113 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '76%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='19%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='37%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='56%'
        this.lm.style.bottom ='67%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='31%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 114 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '78%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='19%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='45%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='37%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='56%'
        this.lm.style.bottom ='67%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='32%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 115 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '56%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '79%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='20%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='46%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='37%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='55%'
        this.lm.style.bottom ='67%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='34%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 116 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '79%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='22%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='47%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='37%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='35%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 117 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '12%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;

        this.metal = document.getElementById("metal")
        this.metal.style.right = '79%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='24%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='49%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='38%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='37%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 118 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '15%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='27%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='48%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='38%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='39%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 119 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '16%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='29%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='48%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='38%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='44%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='41%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 120 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '18%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='32%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='50%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='40%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='46%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='43%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 121 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '21%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='34%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='50%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='40%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='46%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='45%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 122 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '33%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '24%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='38%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='50%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='41%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='46%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='48%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 123 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '37%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '26%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='41%'
        this.mousevalue.style.bottom =54 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='52%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='42%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='47%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='50%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 124 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '39%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '29%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='45%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='42%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='48%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='55%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 125 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '32%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '48%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='45%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;


        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='43%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='48%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='55%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 126 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '36%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='51%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='44%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='49%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='56%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 127 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '39%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='55%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='45%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='50%'
        this.lm.style.bottom ='57%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 128 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '43%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='60%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='46%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='51%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 129 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '44%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='64%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='47%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='51%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity =1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 130 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '47%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '77%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='66%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='48%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='52%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='58%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 0.5;
      }

      if(this.value == 131 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '51%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity =1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '78%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='69%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='49%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='52%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;
      }

      if(this.value == 132 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '55%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '79%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='72%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='50%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='53%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;
      }

      if(this.value == 133 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '59%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '75%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='74%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='51%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='53%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;
      }

      if(this.value == 134 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "none"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '59%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '73%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='77%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='44%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='52%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 0.5;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='53%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 0.5;
      }

      if(this.value == 135 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '52%'
        this.vasechange.style.bottom = '60%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 0.5;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '67%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '72%'
        this.metal.style.bottom = '62%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='79%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='55%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='44%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='55%'
        this.lm.style.bottom ='56%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='46%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 0.5;
      }

      if(this.value == 136 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '52%'
        this.vasechange.style.bottom = '60%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '69%'
        this.dust.style.bottom = '56%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='81%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='56%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='44%'
        this.pow.style.bottom ='52%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='43%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='46%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 0.5;
      }

      if(this.value == 137 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '52%'
        this.vasechange.style.bottom = '60%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '72%'
        this.dust.style.bottom = '56%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='83%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='44%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='42%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='47%'
        this.track.style.bottom ='29%'
        this.track.style.display = "none"
        this.track.style.opacity = 1;
      }

      if(this.value == 138 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '52%'
        this.vasechange.style.bottom = '60%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '75%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='84%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='58%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='44%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='40%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='48%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 139 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '53%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '78%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='85%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='58%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='44%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='40%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='49%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 140 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '53%'
        this.vasechange.style.bottom = '58%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '79%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '80%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='87%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='59%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='45%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='39%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='49%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 141 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '82%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='87%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='59%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='46%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='38%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='50%'
        this.track.style.bottom ='28%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 142 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '84%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='88%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='60%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='46%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='38%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='50%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 143 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '86%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='88%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='60%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='47%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='36%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='42%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='48%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 144 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '88%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='88%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='47%'
        this.pow.style.bottom ='53%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='36%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='52%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='48%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 145 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '88%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='88%'
        this.mousevalue.style.bottom =55 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =54+'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='49%'
        this.pow.style.bottom ='39%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='35%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='54%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 0.5;

        this.track = document.getElementById("track")
        this.track.style.right ='48%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 146 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='76%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =54 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='50%'
        this.pow.style.bottom ='39%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='34%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='55%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='50%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 147 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='76%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='40%'
        this.jaw.style.bottom =55 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='52%'
        this.pow.style.bottom ='39%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='34%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 0.5;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='52%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 148 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '53%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='80%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='39%'
        this.jaw.style.bottom =54 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='53%'
        this.pow.style.bottom ='39%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='59%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='53%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 149 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '51%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;

        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '30%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='81%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='53%'
        this.pow.style.bottom ='39%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='60%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 150 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '51%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;



        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity =   1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '31%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='84%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='55%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='62%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 151 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '51%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;



        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '33%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='85%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='55%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='63%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 152 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '33%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='87%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='57%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='64%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity =1;
      }

      if(this.value == 153 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '90%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '29%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='89%'
        this.mousevalue.style.bottom =60 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='57%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='59%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='65%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='54%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity =1;
      }

      if(this.value == 154 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '89%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '26%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =59 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
       this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='59%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='31%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='66%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='55%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 155 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '89%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '24%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =58 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
       this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='59%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "none"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='31%'
        this.lm.style.bottom ='59%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='67%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='55%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 156 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '54%'
        this.vasechange.style.bottom = '49%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '89%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '22%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =57 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='61%'
        this.jaw.style.bottom =59 +'%'
       this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='23%'
        this.pow.style.bottom ='38%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='31%'
        this.lm.style.bottom ='61%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='68%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='55%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 157 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '78%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '87%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='91%'
        this.mousevalue.style.bottom =57 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='24%'
        this.pow.style.bottom ='37%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='31%'
        this.lm.style.bottom ='61%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='29%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='56%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 158 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '78%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '87%'
        this.dust.style.bottom = '54%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '42%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "none"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='91%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='24%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='31%'
        this.lm.style.bottom ='61%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='31%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='56%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 159 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '78%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '85%'
        this.dust.style.bottom = '53%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '12%'
        this.metal.style.bottom = '64%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =57 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 0.5;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='25%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='32%'
        this.lm.style.bottom ='61%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='31%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity =1;
      }

      if(this.value == 160 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '78%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '84%'
        this.dust.style.bottom = '52%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '10%'
        this.metal.style.bottom = '64%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='33%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='26%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='32%'
        this.lm.style.bottom ='61%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='31%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 161 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '78%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '83%'
        this.dust.style.bottom = '52%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '8%'
        this.metal.style.bottom = '64%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='33%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='26%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='33%'
        this.lm.style.bottom ='61%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 0.5;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='31%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }
      if(this.value == 162 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '77%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '81%'
        this.dust.style.bottom = '52%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '8%'
        this.metal.style.bottom = '62%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='33%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='27%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='57%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='32%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 163 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '81%'
        this.dust.style.bottom = '52%'        
        this.dust.style.display = "inline"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '6%'
        this.metal.style.bottom = '62%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 0.5;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='90%'
        this.mousevalue.style.bottom =56 +'%'
        this.mousevalue.style.display = "none"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='33%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='28%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='57%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='33%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }

      if(this.value == 164 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '75%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '5%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '4%'
        this.metal.style.bottom = '63%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='8%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='29%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='57%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "none"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='34%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      } 
      if(this.value == 165 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '73%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '5%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '41%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='9%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='31%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='36%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='35%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      } 
      if(this.value == 166 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '72%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '5%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '45%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='9%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='32%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='37%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='36%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='58%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      } 
      if(this.value == 167 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '71%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '5%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '50%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='10%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='57%'
        this.jaw.style.bottom =58 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='33%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='38%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='37%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      } 
      if(this.value == 168 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '70%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '5%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '54%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='12%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='33%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='35%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='39%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='39%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }
      if(this.value == 169 ){
        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '68%'
        this.vasechange.style.bottom = '46%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;


        this.dust = document.getElementById("dust")
        this.dust.style.right = '5%'
        this.dust.style.bottom = '55%'        
        this.dust.style.display = "none"
        this.dust.style.opacity = 1;


        this.metal = document.getElementById("metal")
        this.metal.style.right = '57%'
        this.metal.style.bottom = '60%'        
        this.metal.style.display = "inline"
        this.metal.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='14%'
        this.mousevalue.style.bottom =46 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='33%'
        this.jaw.style.bottom =57 +'%'
        this.jaw.style.display = "none"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='37%'
        this.pow.style.bottom ='36%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='40%'
        this.lm.style.bottom ='58%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='40%'
        this.dpi.style.bottom ='36%'
        this.dpi.style.display = "inline"
        this.dpi.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='27%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;
      }
     }
     backtoweb(){
      window.open("https://www.propelind.com/","_self");

     }
     backtowebhome(){
      window.open("https://3dproducttour.propelind.com/","_self");

     }
    functioncall(){
      this.value = this.val + 1
      this.val = this.value
      this.sliderEvent()

     } 
     functioncallback(){
      //  return false

      this.value = this.valback - 1
      this.valback = this.value
      this.sliderEvent()
      if(this.value == 72){
        this.slideron = 1
        // this.ngxService.stop()

      }
     } 
     fromenv(){
       return false
      this.firstimg = 3

      this.fromfeeddisplay = document.getElementById("frame-92" )
      this.fromfeeddisplay.style.display = "none"

      this.fromenvdisplay = document.getElementById("frame-72" )
      this.fromenvdisplay.style.display = "none"

      this.firdisplay = document.getElementById("frame-" +this.value)
      this.firdisplay.style.display = "none"
      this.otherdisplay = document.getElementById("frame-73" )
      this.otherdisplay.style.display = "inline"

      this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '22%'
        this.vasechange.style.bottom = '69%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='71%'
        this.mousevalue.style.bottom =68 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='59%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='53%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;

        this.lm = document.getElementById("lm")
        this.lm.style.right ='37%'
        this.lm.style.bottom ='70%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;
     
      this.value = 72
     }

     fromfeedho(){
       return false
      this.firstimg = 3
    
      this.fromenvdisplay = document.getElementById("frame-73" )
      this.fromenvdisplay.style.display = "none"

      this.fromfeeddisplay = document.getElementById("frame-92" )
      this.fromfeeddisplay.style.display = "none"

      this.firdisplay = document.getElementById("frame-" +this.value)
      this.firdisplay.style.display = "none"

      this.otherdisplay = document.getElementById("frame-72" )
      this.otherdisplay.style.display = "inline"

      this.lm = document.getElementById("lm")
        this.lm.style.right ='36%'
        this.lm.style.bottom ='70%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '18%'
        this.vasechange.style.bottom = '69%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='72%'
        this.mousevalue.style.bottom =69 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='59%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='53%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;
      // this.value = 72

     }

     fromtrack(){
       return false
      this.fromfeeddisplay = document.getElementById("frame-73" )
      this.fromfeeddisplay.style.display = "none"

        this.fromfeeddisplay = document.getElementById("frame-72" )
      this.fromfeeddisplay.style.display = "none"

      this.firdisplay = document.getElementById("frame-" +this.value)
      this.firdisplay.style.display = "none"
      this.otherdisplay = document.getElementById("frame-92" )
      this.otherdisplay.style.display = "inline"

      this.vasechange = document.getElementById("vasechange")
      this.vasechange.style.right = '84%'
      this.vasechange.style.bottom = '70%'        
      this.vasechange.style.display = "inline"
      this.vasechange.style.opacity = 1;
      

      this.mousevalue = document.getElementById("mousevalue")
      this.mousevalue.style.right ='32%'
      this.mousevalue.style.bottom =68 +'%'
      this.mousevalue.style.display = "inline"
      this.mousevalue.style.opacity = 1;

      this.jaw = document.getElementById("jaw")
      this.jaw.style.right ='59%'
      this.jaw.style.bottom =59 +'%'
      this.jaw.style.display = "none"
      this.jaw.style.opacity = 0.5;

      this.pow = document.getElementById("pow")
      this.pow.style.right ='56%'
      this.pow.style.bottom ='59%'
      this.pow.style.display = "none"
      this.pow.style.opacity = 0.5;

      this.lm = document.getElementById("lm")
      this.lm.style.right ='58%'
      this.lm.style.bottom ='70%'
      this.lm.style.display = "inline"
      this.lm.style.opacity = 1;

      this.dpi = document.getElementById("dpi")
      this.dpi.style.right ='57%'
      this.dpi.style.bottom ='47%'
      this.dpi.style.display = "inline"
      this.dpi.style.opacity = 1;

      this.track = document.getElementById("track")
      this.track.style.right ='54%'
      this.track.style.bottom ='29%'
      this.track.style.display = "none"
      this.track.style.opacity = 0.5;
     }
     imagemoveforpopup(){
     
      return false
      this.firstimg = 2 

      this.lm = document.getElementById("lm")
        this.lm.style.right ='36%'
        this.lm.style.bottom ='70%'
        this.lm.style.display = "inline"
        this.lm.style.opacity = 1;

        this.vasechange = document.getElementById("vasechange")
        this.vasechange.style.right = '18%'
        this.vasechange.style.bottom = '69%'        
        this.vasechange.style.display = "inline"
        this.vasechange.style.opacity = 1;
        

        this.mousevalue = document.getElementById("mousevalue")
        this.mousevalue.style.right ='72%'
        this.mousevalue.style.bottom =69 +'%'
        this.mousevalue.style.display = "inline"
        this.mousevalue.style.opacity = 1;

        this.track = document.getElementById("track")
        this.track.style.right ='57%'
        this.track.style.bottom ='29%'
        this.track.style.display = "inline"
        this.track.style.opacity = 1;

        this.dpi = document.getElementById("dpi")
        this.dpi.style.right ='57%'
        this.dpi.style.bottom ='47%'
        this.dpi.style.display = "none"
        this.dpi.style.opacity = 1;

        this.jaw = document.getElementById("jaw")
        this.jaw.style.right ='59%'
        this.jaw.style.bottom =59 +'%'
        this.jaw.style.display = "inline"
        this.jaw.style.opacity = 1;

        this.pow = document.getElementById("pow")
        this.pow.style.right ='53%'
        this.pow.style.bottom ='59%'
        this.pow.style.display = "inline"
        this.pow.style.opacity = 1;


        this.firdisplay = document.getElementById("frame-" +this.value)
        this.firdisplay.style.display = "none"

        this.firdisplay = document.getElementById("frame-92")
        this.firdisplay.style.display = "none"

        this.firdisplay = document.getElementById("frame-73")
        this.firdisplay.style.display = "none"
      
         this.otherdisplay = document.getElementById("frame-72" )
      this.otherdisplay.style.display = "inline"
      this.value = 72

     } 

     imagemoveforpopupdualpow(){
        return false
      this.firstimg = 2 

      this.vasechange = document.getElementById("vasechange")
      this.vasechange.style.right = '84%'
      this.vasechange.style.bottom = '70%'        
      this.vasechange.style.display = "inline"
      this.vasechange.style.opacity = 1;
      

      this.mousevalue = document.getElementById("mousevalue")
      this.mousevalue.style.right ='32%'
      this.mousevalue.style.bottom =68 +'%'
      this.mousevalue.style.display = "inline"
      this.mousevalue.style.opacity = 1;

      this.jaw = document.getElementById("jaw")
      this.jaw.style.right ='59%'
      this.jaw.style.bottom =59 +'%'
      this.jaw.style.display = "none"
      this.jaw.style.opacity = 0.5;

      this.pow = document.getElementById("pow")
      this.pow.style.right ='56%'
      this.pow.style.bottom ='59%'
      this.pow.style.display = "none"
      this.pow.style.opacity = 0.5;

      this.lm = document.getElementById("lm")
      this.lm.style.right ='57%'
      this.lm.style.bottom ='70%'
      this.lm.style.display = "inline"
      this.lm.style.opacity = 1;

      this.dpi = document.getElementById("dpi")
      this.dpi.style.right ='56%'
      this.dpi.style.bottom ='47%'
      this.dpi.style.display = "inline"
      this.dpi.style.opacity = 1;

      this.track = document.getElementById("track")
      this.track.style.right ='54%'
      this.track.style.bottom ='29%'
      this.track.style.display = "none"
      this.track.style.opacity = 0.5;

      this.firdisplay = document.getElementById("frame-" +this.value)
      this.firdisplay.style.display = "none"
      this.firdisplay = document.getElementById("frame-72")
      this.firdisplay.style.display = "none"
    
       this.otherdisplay = document.getElementById("frame-92" )
    this.otherdisplay.style.display = "inline"
    this.value = 92
     }
     dosomething(idval : any){
      //  console.log(idval.target.id)
     }

     contactuspage(){
      window.open("https://www.propelind.com/contact/","_self");
    }
    downloadpdf(downloadform:any){
    //  console.log(downloadform.value)
     var data = {
      'value': downloadform.value
    };
    var method = "post";
    var url = "api/adduserdetaildownload";
    this.AjaxServices.adddownloadform(data, url)
      .subscribe(
        (datas:any) => {
         
            if (datas.code  == 200) {
              location.href = "https://www.propelind.com/wp-content/themes/propel/brochure/track-mounted-screen.pdf";

                    }
            else { 
              // this.toastr.error('error');
            }
        },
        (err) => {
          // this.toastr.error('error');
        });   
   }
   reqforquotefunction(quoteform:any){
    // console.log(quoteform.value)
    var data = {
     'value': quoteform.value
   };
   var method = "post";
   var url = "api/adduserdetailquote";
   this.AjaxServices.adddownloadform(data, url)
     .subscribe(
       (datas:any) => {
        
           if (datas.code  == 200) {
            this.reqformshow = 2
                   }
           else { 
             // this.toastr.error('error');
           }
       },
       (err) => {
         // this.toastr.error('error');
       });   
  }
}
